import apiClient from "./axiosClient"; 

// ============================================
// REGISTER DATA APIs
// ============================================

/**
 * Load all districts
 * Endpoint: POST /api/load-districts
 * Request: {}
 */
export const loadDistricts = async () => {
  try {
    const res = await apiClient.post("/api/load-districts", {});
    return res.data;
  } catch (err) {
    throw err?.response?.data || {
      status: "error",
      message: "Failed to fetch districts: Please try again later.",
    };
  }
};

/**
 * Load taluks by district ID
 * Endpoint: POST /api/load-taluks
 * Request: { district_id: "base64_encoded_id" }
 */
export const loadTaluks = async (districtId) => {
  try {
    const res = await apiClient.post("/api/load-taluks", {
      district_id: districtId,
    });
    return res.data;
  } catch (err) {
    throw err?.response?.data || {
      status: "error",
      message: "Failed to load taluks. Please try again later.",
    };
  }
};

/**
 * Load society categories
 * Endpoint: POST /api/load-society-categories
 * Request: {}
 */
export const loadCategory = async () => {
  try {
    const res = await apiClient.post("/api/load-society-categories", {});
    return res.data;
  } catch (err) {
    throw err?.response?.data || {
      status: "error",
      message: "Failed to load categories. Please try again later.",
    };
  }
};

/**
 * Load society information
 * Endpoint: POST /api/get-society-info
 * Request: { district_id, taluk_id, society_category_id, reg_no }
 */
export const getSocietyInfo = async ({ districtId, talukId, societyCategoryId, regNo }) => {
  try {
    const res = await apiClient.post("/api/get-society-info", {
      district_id: districtId,
      taluk_id: talukId,
      society_category_id: societyCategoryId,
      reg_no: regNo,
    });
    return res.data;
  } catch (err) {
    throw err?.response?.data || {
      status: "error",
      message: "Failed to fetch society information.",
    };
  }
};

/**
 * Send registration OTP
 * Endpoint: POST /api/society/send-registration-otp
 * Request: { society_branch_id: "base64_encoded_branch_id" }
 */
export const sendRegistrationOTP = async (societyBranchId) => {
  try {
    const res = await apiClient.post("/api/society/send-registration-otp", {
      society_branch_id: societyBranchId,
    });
    return res.data;
  } catch (err) {
    throw err?.response?.data || {
      status: "error",
      message: "Failed to send OTP. Please try again.",
    };
  }
};

/**
 * Verify registration OTP
 * Endpoint: POST /api/society/verify-registration-otp
 * Request: { society_branch_id: "base64_encoded_branch_id", otp: "string" }
 */
export const verifyRegistrationOTP = async (societyBranchId, otp) => {
  try {
    const res = await apiClient.post("/api/society/verify-registration-otp", {
      society_branch_id: societyBranchId,
      otp: otp,
    });
    return res.data;
  } catch (err) {
    throw err?.response?.data || {
      status: "error",
      message: "OTP verification failed. Please try again.",
    };
  }
};

/**
 * Register secretary seat
 * Endpoint: POST /api/register-secretary-seat
 * Request: {
 *   society_branch_id: "base64",
 *   secretary_name: "string",
 *   mobile_number: "string",
 *   password: "string",
 *   password_confirmation: "string"
 * }
 */
export const registerSecretarySeat = async ({ societyBranchId, secretaryName, mobileNumber, password, passwordConfirmation }) => {
  try {
    const res = await apiClient.post("/api/register-secretary-seat", {
      society_branch_id: societyBranchId,
      secretary_name: secretaryName,
      mobile_number: mobileNumber,
      password: password,
      password_confirmation: passwordConfirmation,
    });
    return res.data;
  } catch (err) {
    throw err?.response?.data || {
      status: "error",
      message: "Registration failed. Please try again.",
    };
  }
};


